import React, { useState, useCallback, useEffect, useRef, useMemo } from 'react';
import './Rank.css';

// ══════════════════════════════════════════════════════════════════
// DATA
// ══════════════════════════════════════════════════════════════════

// imageFile is the filename inside /rank-items/ — drop images there with these exact names.
// Supports .jpg or .png (update the extension in imageFile if you use .png).
const GIFTS = [
  { id:'g1',  name:'Ultimate Bath at Aire Ancient Baths',
    bullets:['Premium Wellness & Spa Experience','Luxury spa experience featuring thermal baths, massage, and deep relaxation in Tribeca','Combines ancient bath rituals with modern wellness in a candlelit atmosphere','Designed for full-body recovery, stress relief, and sensory escape'],
    emoji:'🛁', gradient:'linear-gradient(135deg,#006994,#4fc3f7)', price:230, imageFile:'aire-ancient-baths.jpg' },
  { id:'g2',  name:'2 tickets to Six Flags Great Adventure in NJ, Fast Track included!',
    bullets:['Two fast-pass tickets to Six Flags Great Adventure','Includes priority Fast Track access to maximize time on roller coasters','Perfect for thrill seekers, friend outings, or summer adventures','Transport to the park not included'],
    emoji:'🎢', gradient:'linear-gradient(135deg,#c62828,#ff8f00)', price:300, imageFile:'six-flags.jpg' },
  { id:'g3',  name:'French food cooking class for two at "sur la table"',
    bullets:['Hands-on French cooking class for two featuring classic techniques and elegant dishes','Interactive culinary experience guided by professional chefs','Perfect date night or shared experience for food lovers','Learn restaurant-style recipes in a fun, social atmosphere'],
    emoji:'🍳', gradient:'linear-gradient(135deg,#bf360c,#ffb300)', price:150, imageFile:'sur-la-table.png' },
  { id:'g4',  name:'ClassPass Gift Card ($200)',
    bullets:['$200 ClassPass gift card for fitness, dance, wellness, and studio experiences','Access to yoga, Pilates, dance, and strength training','Flexible wellness gift tailored to different interests and routines','Encourages exploration, movement, and self-care experiences'],
    emoji:'🧘', gradient:'linear-gradient(135deg,#4a148c,#e040fb)', price:200, imageFile:'classpass.jpeg' },
  { id:'g5',  name:'32 Inch UltraGear QHD 1440P 180Hz 1ms AMD FreeSync HDR10 1000R Curved Monitor',
    bullets:['Curved 32" QHD gaming monitor with immersive visuals and ultra-smooth performance','High refresh rate and vivid color contrast for gaming, movies, and multitasking','Sleek modern design that upgrades any desk or entertainment setup'],
    emoji:'🖥️', gradient:'linear-gradient(135deg,#0d1b2a,#1565c0)', price:380, imageFile:'lg-monitor.jpg' },
  { id:'g6',  name:'Insignia - 50" Class F50 Series LED 4K UHD Smart Fire TV',
    bullets:['4K Ultra HD Display with HDR: vibrant, detailed visuals','Built-in Fire TV and Alexa Voice Control, hands-free access to streaming apps','Immersive Audio: DTS Studio Sound for clear, rich sound'],
    emoji:'📺', gradient:'linear-gradient(135deg,#1a237e,#42a5f5)', price:300, imageFile:'insignia-tv.jpg' },
  { id:'g7',  name:'Apple Belkin UltraCharge Pro 3-in-1 Magnetic Charging Dock',
    bullets:['3-in-1 magnetic charging dock for iPhone, Apple Watch, and AirPods','Sleek all-in-one setup that reduces cable clutter','Fast wireless charging with premium minimalist design'],
    emoji:'🔌', gradient:'linear-gradient(135deg,#424242,#bdbdbd)', price:120, imageFile:'belkin-charger.jpeg' },
  { id:'g8',  name:'Beats Solo 4 - On-Ear Wireless Headphones',
    bullets:['Wireless on-ear headphones with premium sound and long battery life','Stylish lightweight design built for comfort and everyday listening','Personalized spatial audio and strong bass performance'],
    emoji:'🎧', gradient:'linear-gradient(135deg,#880e4f,#f48fb1)', price:200, imageFile:'beats-solo-4.jpeg' },
  { id:'g9',  name:'JBL Charge 6 Bluetooth Speaker',
    bullets:['Portable Bluetooth speaker with powerful sound, deep bass, and long battery life','Waterproof and durable design for travel, parties, and outdoor use','Doubles as a power bank for charging devices on the go'],
    emoji:'🔊', gradient:'linear-gradient(135deg,#1a237e,#1976d2)', price:180, imageFile:'jbl-charge-6.png' },
  { id:'g10', name:'Ikea Hovet Mirror',
    bullets:['Large gold-framed IKEA HOVET mirror with clean modern styling','Makes spaces feel brighter, larger, and more open','Versatile floor or wall mirror ideal for bedrooms and apartments','Functional décor piece with minimalist Scandinavian design'],
    emoji:'🪞', gradient:'linear-gradient(135deg,#5d4037,#ffd54f)', price:130, imageFile:'ikea-mirror.jpg' },
  { id:'g11', name:'Vankyo Leisure 570D Portable Projector',
    bullets:['Compact projector that transforms any wall into a home theater experience','Large-screen viewing for movies, gaming, sports, and outdoor movie nights','Compatible with streaming devices, laptops, and gaming consoles'],
    emoji:'📽️', gradient:'linear-gradient(135deg,#1a1a2e,#7c4dff)', price:90, imageFile:'vankyo-projector.jpg' },
  { id:'g12', name:'Polaroid 600 peanuts beagle scouts instant film camera',
    bullets:['Retro-style Polaroid instant camera for capturing and printing memories instantly','Unique collectible design with nostalgic analog photography charm','Great for travel, parties, journals, and creative keepsakes'],
    emoji:'📷', gradient:'linear-gradient(135deg,#1b5e20,#66bb6a)', price:120, imageFile:'polaroid-camera.jpg' },
  { id:'g13', name:'Celestron AstroMaster 70AZ Telescope',
    bullets:['Solid and beginner-friendly refractor telescope for easy stargazing','Views of the Moon, planets, and bright deep-sky objects','Lightweight mount and tripod, simple to set up at home or outdoors'],
    emoji:'🔭', gradient:'linear-gradient(135deg,#0a0a1a,#283593)', price:85, imageFile:'celestron-telescope.jpg' },
  { id:'g14', name:'Audio-Technica AT-LP60X Fully Automatic Belt-Drive Turntable (record player)',
    bullets:['Fully automatic belt-drive turntable for easy vinyl listening','Rich analog sound with simple plug-and-play setup','Compatible with modern speaker systems','Great entry-level record player for music lovers and vinyl collectors'],
    emoji:'💿', gradient:'linear-gradient(135deg,#212121,#546e7a)', price:110, imageFile:'audio-technica-turntable.jpg' },
  { id:'g15', name:'C40II full-size student classical guitar',
    bullets:['Full-size classical guitar with warm, balanced sound','Elegant natural wood finish with nylon strings for a smooth feel','Yamaha craftsmanship known for durability, tone quality, and reliability'],
    emoji:'🎸', gradient:'linear-gradient(135deg,#4e342e,#ffa726)', price:100, imageFile:'yamaha-guitar.jpg' },
  { id:'g16', name:'27″ Grande LAVA® Lamp (largest in the market!)',
    bullets:['Oversized 27-inch lava lamp, the largest available on the market','Mesmerizing flowing wax creates ambient lighting and retro-futuristic decor','Statement piece for bedrooms, living spaces, or creative studios'],
    emoji:'🔮', gradient:'linear-gradient(135deg,#4a148c,#ff6f00)', price:160, imageFile:'lava-lamp.jpg' },
  { id:'g17', name:'WalkingPad Step Station',
    bullets:['Compact walking pad and step station for movement while working or studying','Encourages daily activity, cardio, and wellness from home','Space-saving design fits easily into apartments or office setups'],
    emoji:'🏃', gradient:'linear-gradient(135deg,#b71c1c,#37474f)', price:280, imageFile:'walkingpad.jpg' },
  { id:'g18', name:'50-minute full body massage with Spa access',
    bullets:['Recovery-focused full-body massage to relieve tension, restore energy, and promote deep relaxation','Access to thermal pools, cold plunges, saunas, and steam rooms before or after treatment','A unique NYC escape perfect for relaxation, self-care, and recharging from city life'],
    emoji:'💆', gradient:'linear-gradient(135deg,#3e2723,#a1887f)', price:160, imageFile:'bathhouse-spa.jpg' },
  { id:'g19', name:'Caring Mill by Aura Ease Migraine & Eye Reliever with Compression & Heat',
    bullets:['Soothing compression and gentle heat ease headaches, eye strain, sinus pressure, and tension','Soft, comfortable design for a relaxing spa-like experience at home or traveling','Rechargeable and easy to use for quick relief during workdays or study sessions'],
    emoji:'😌', gradient:'linear-gradient(135deg,#880e4f,#f8bbd0)', price:35, imageFile:'eye-reliever.jpg' },
];

// Rainbow order as "Others' Choices" baseline for colors
const COLORS_DATA = [
  { id:'c1',  name:'Red',    emoji:'🔴', gradient:'linear-gradient(135deg,#c62828,#ef5350)', price:12 },
  { id:'c2',  name:'Orange', emoji:'🟠', gradient:'linear-gradient(135deg,#e65100,#ffa726)', price:11 },
  { id:'c3',  name:'Yellow', emoji:'🟡', gradient:'linear-gradient(135deg,#f57f17,#ffee58)', price:10 },
  { id:'c4',  name:'Green',  emoji:'🟢', gradient:'linear-gradient(135deg,#1b5e20,#66bb6a)', price:9 },
  { id:'c5',  name:'Teal',   emoji:'🩵', gradient:'linear-gradient(135deg,#006064,#4dd0e1)', price:8 },
  { id:'c6',  name:'Blue',   emoji:'🔵', gradient:'linear-gradient(135deg,#0d47a1,#42a5f5)', price:7 },
  { id:'c7',  name:'Purple', emoji:'🟣', gradient:'linear-gradient(135deg,#4a148c,#ce93d8)', price:6 },
  { id:'c8',  name:'Pink',   emoji:'🩷', gradient:'linear-gradient(135deg,#880e4f,#f48fb1)', price:5 },
  { id:'c9',  name:'Mint',   emoji:'🌿', gradient:'linear-gradient(135deg,#00695c,#80cbc4)', price:4 },
  { id:'c10', name:'Brown',  emoji:'🟤', gradient:'linear-gradient(135deg,#3e2723,#a1887f)', price:3 },
  { id:'c11', name:'White',  emoji:'⚪', gradient:'linear-gradient(135deg,#eceff1,#fafafa)', price:2, textColor:'#555' },
  { id:'c12', name:'Black',  emoji:'⚫', gradient:'linear-gradient(135deg,#000000,#37474f)', price:1 },
];

// ══════════════════════════════════════════════════════════════════
// BINARY INSERTION SORT STATE MACHINE
// ══════════════════════════════════════════════════════════════════

function shuffled(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function initSort(items) {
  const s = shuffled(items);
  // Estimate max comparisons for progress display
  let maxC = 0;
  for (let k = 1; k < s.length; k++) maxC += Math.ceil(Math.log2(k + 1));
  return {
    sorted: [s[0]],
    current: s[1],
    remaining: s.slice(2),
    lo: 0,
    hi: 0,
    totalItems: s.length,
    maxComparisons: maxC,
    comparisons: 0,
    done: false,
  };
}

function getComparison(state) {
  if (state.done) return null;
  const mid = Math.floor((state.lo + state.hi) / 2);
  return { a: state.current, b: state.sorted[mid], mid };
}

// choice: 'a' = user prefers current item, 'b' = user prefers sorted[mid]
function applyChoice(state, choice) {
  if (state.done) return state;
  const mid = Math.floor((state.lo + state.hi) / 2);
  let { lo, hi, sorted, current, remaining, comparisons, maxComparisons } = state;
  comparisons++;

  let newLo = lo, newHi = hi;
  if (choice === 'a') {
    newHi = mid - 1; // current is better → search left (better) side
  } else {
    newLo = mid + 1; // sorted[mid] is better → search right (worse) side
  }

  if (newLo > newHi) {
    const newSorted = [...sorted.slice(0, newLo), current, ...sorted.slice(newLo)];
    if (remaining.length === 0) {
      return { ...state, sorted: newSorted, done: true, comparisons, maxComparisons };
    }
    const [next, ...rest] = remaining;
    return {
      ...state,
      sorted: newSorted,
      current: next,
      remaining: rest,
      lo: 0,
      hi: newSorted.length - 1,
      comparisons,
    };
  }
  return { ...state, lo: newLo, hi: newHi, comparisons };
}

function getProgress(state) {
  if (state.done) return 1;
  const itemsPlaced = state.sorted.length - 1;
  return itemsPlaced / (state.totalItems - 1);
}

// ══════════════════════════════════════════════════════════════════
// FIND-TOP STATE MACHINE (linear tournament — n-1 comparisons to find #1)
// ══════════════════════════════════════════════════════════════════

function initFindTop(items) {
  const s = shuffled(items);
  return {
    champion: s[0],
    candidates: s.slice(1),
    losers: [],
    comparisons: 0,
    totalItems: s.length,
    done: false,
  };
}

function getFindTopComp(state) {
  if (state.done || state.candidates.length === 0) return null;
  return { a: state.champion, b: state.candidates[0] };
}

function applyFindTopChoice(state, choice) {
  if (state.done) return state;
  const [head, ...rest] = state.candidates;
  const newChampion = choice === 'a' ? state.champion : head;
  const loser       = choice === 'a' ? head : state.champion;
  const newLosers   = [...state.losers, loser];
  const done        = rest.length === 0;
  return {
    ...state,
    champion:   newChampion,
    candidates: rest,
    losers:     newLosers,
    comparisons: state.comparisons + 1,
    done,
  };
}

// ══════════════════════════════════════════════════════════════════
// PRICE RANK HELPERS
// ══════════════════════════════════════════════════════════════════

function getPriceRanks(items) {
  const sorted = [...items].sort((a, b) => b.price - a.price);
  const ranks = {};
  sorted.forEach((item, i) => { ranks[item.id] = i + 1; });
  return ranks;
}

function getArrowInfo(userRank, baselineRank) {
  const diff = baselineRank - userRank; // positive = user ranked higher
  if (diff >= 5)  return { symbol: '▲▲', label: `+${diff}`, color: '#2e7d32' };
  if (diff >= 2)  return { symbol: '▲',  label: `+${diff}`, color: '#4caf50' };
  if (diff <= -5) return { symbol: '▼▼', label: `${diff}`,  color: '#b71c1c' };
  if (diff <= -2) return { symbol: '▼',  label: `${diff}`,  color: '#f44336' };
  return { symbol: '━', label: '~', color: '#9e9e9e' };
}

// ══════════════════════════════════════════════════════════════════
// SMALL HELPER COMPONENTS
// ══════════════════════════════════════════════════════════════════

function FloatLabel({ text, x, y, onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 800);
    return () => clearTimeout(t);
  }, [onDone]);
  return (
    <div className="rank-float-label" style={{ left: x, top: y }}>
      {text}
    </div>
  );
}

function ItemImage({ item, height = 140, borderRadius = 0, objectFit = 'cover' }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError]   = useState(false);
  const hasImage = !!item.imageFile && !error;
  return (
    <div style={{
      height,
      background: item.gradient,
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      borderRadius,
      width: borderRadius ? height : undefined,
    }}>
      {hasImage && (
        <img
          src={`/rank-items/${item.imageFile}`}
          alt={item.name}
          onLoad={() => setLoaded(true)}
          onError={() => setError(true)}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit,
            opacity: loaded ? 1 : 0,
            transition: 'opacity 0.25s ease',
          }}
        />
      )}
      {(!hasImage || !loaded) && (
        <span style={{
          fontSize: Math.round(height * 0.38),
          lineHeight: 1,
          position: 'relative',
          zIndex: 1,
          filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))',
        }}>
          {item.emoji}
        </span>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════
// INTRO SCREEN
// ══════════════════════════════════════════════════════════════════

function IntroScreen({ onStart, mode, hasCompletedThings }) {
  const isGifts = mode === 'gifts';

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '24px 16px 40px' }}>
      {/* Header */}
      <div style={{ textAlign: 'center', paddingTop: 20 }}>
        <div style={{ fontSize: 64, marginBottom: 8 }} className="rank-bounce">
          {isGifts ? '⚡' : '🎨'}
        </div>
        <h1 style={{
          fontFamily: "'Fredoka One', cursive",
          fontSize: 'clamp(28px,6vw,48px)',
          margin: 0,
          background: 'linear-gradient(135deg,#7c4dff,#42a5f5)',
          WebkitBackgroundClip: 'text', backgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          lineHeight: 1.1,
        }}>
          {isGifts ? 'The Ranker' : 'Color Ranker'}
        </h1>
        <p style={{ color: '#555', fontSize: 15, marginTop: 8, fontWeight: 600 }}>
          {isGifts
            ? 'Find your favorites, one vote at a time!'
            : 'Find your true favorite color, one vote at a time.'}
        </p>
      </div>

      {/* Combined instruction box */}
      <div className="rank-bubble" style={{ margin: '20px 0 24px', padding: '18px 20px' }}>
        <p style={{ margin: '0 0 12px', fontSize: 14, color: '#333', fontWeight: 800 }}>
          ⚡ How It Works
        </p>
        <p style={{ margin: '0 0 14px', fontSize: 13, color: '#555', lineHeight: 1.65 }}>
          Pick between two options at a time, and the algorithm builds your full ranking
          from those simple choices. It's called{' '}
          <strong style={{ color: '#7c4dff' }}>pairwise comparison</strong>, and it's
          the same technique used in sports tournaments, chess rankings, and even some dating apps!
        </p>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {[
            { emoji: '👀', label: 'See two options' },
            { emoji: '👆', label: 'Pick your fave' },
            { emoji: '🔁', label: 'Repeat' },
            { emoji: '🏆', label: 'Get ranked!' },
          ].map((s, i) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', gap: 5,
              background: '#f5f5ff', borderRadius: 10, padding: '6px 10px',
              fontSize: 12, fontWeight: 700, color: '#555',
            }}>
              <span style={{ fontSize: 15 }}>{s.emoji}</span>
              {s.label}
              {i < 3 && <span style={{ color: '#aaa', marginLeft: 2 }}>›</span>}
            </div>
          ))}
        </div>

        {/* Mini demo */}
        <div style={{ marginTop: 16, borderTop: '1px solid #eee', paddingTop: 14 }}>
          <p style={{ margin: '0 0 10px', fontWeight: 700, fontSize: 11, color: '#aaa', textAlign: 'center', letterSpacing: 1, textTransform: 'uppercase' }}>
            Preview
          </p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
            {[{e:'🎢',l:'Option A'},{e:'🎧',l:'Option B'}].map((item, idx) => (
              <React.Fragment key={item.e}>
                {idx === 1 && <div className="rank-vs" style={{ width:32,height:32,fontSize:11 }}>VS</div>}
                <div style={{
                  flex: 1, maxWidth: 130, borderRadius: 12, border: '2px solid #e0e0e0',
                  background: '#fff', padding: '10px 8px', textAlign: 'center',
                  opacity: idx === 1 ? 0.55 : 1,
                  boxShadow: idx === 0 ? '0 0 0 3px rgba(76,175,80,0.3)' : 'none',
                  borderColor: idx === 0 ? '#4caf50' : '#e0e0e0',
                }}>
                  <div style={{ fontSize: 26 }}>{item.e}</div>
                  <div style={{ fontSize: 10, fontWeight: 700, color: '#333', marginTop: 4 }}>{item.l}</div>
                  {idx === 0 && (
                    <div style={{ fontSize: 9, color: '#4caf50', fontWeight: 800, marginTop: 2 }}>WINNER</div>
                  )}
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      {/* Start button */}
      <button
        className="rank-btn rank-bounce"
        onClick={() => onStart(mode)}
        style={{
          width: '100%', padding: '18px 0', fontSize: 20,
          background: 'linear-gradient(135deg,#7c4dff,#42a5f5)',
          color: '#fff', boxShadow: '0 6px 24px rgba(124,77,255,0.4)',
          letterSpacing: 1,
        }}
      >
        {isGifts ? '⚡ Start Ranking Things!' : '🎨 Start Ranking Colors!'}
      </button>

      {/* Colors option - only unlocked after completing things */}
      {isGifts && hasCompletedThings && (
        <button
          className="rank-btn"
          onClick={() => onStart('colors')}
          style={{
            width: '100%', padding: '14px 0', fontSize: 16, marginTop: 12,
            background: '#fff', color: '#7c4dff',
            border: '2.5px solid #7c4dff',
          }}
        >
          🎨 Rank Colors Instead
        </button>
      )}

      {!isGifts && (
        <button
          className="rank-btn"
          onClick={() => onStart('gifts')}
          style={{
            width: '100%', padding: '14px 0', fontSize: 16, marginTop: 12,
            background: '#fff', color: '#7c4dff',
            border: '2.5px solid #7c4dff',
          }}
        >
          ⚡ Rank Things Instead
        </button>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════
// COMPARE CARD
// ══════════════════════════════════════════════════════════════════

function CompareCard({ item, side, state, onChoose }) {
  const isChosen  = state === 'chosen';
  const isRejected = state === 'rejected';
  const [pressed, setPressed] = useState(false);

  const cardCls = [
    'rank-card',
    state === 'idle' ? (side === 'a' ? 'rank-card-a' : 'rank-card-b') : '',
    isChosen   ? (side === 'a' ? 'rank-winner-a' : 'rank-winner-b') : '',
    isRejected ? (side === 'a' ? 'rank-loser'    : 'rank-loser-b')  : '',
  ].join(' ');

  return (
    <div
      className={cardCls}
      onClick={() => state === 'idle' && onChoose()}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      onMouseLeave={() => setPressed(false)}
      style={{
        flex: '1 1 0',
        minWidth: 0,
        transform: pressed && state === 'idle' ? 'scale(0.97)' : undefined,
        borderColor: isChosen ? '#4caf50' : undefined,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Item image */}
      <div style={{ position: 'relative', flexShrink: 0 }}>
        <ItemImage item={item} height={150} objectFit="contain" />
        {isChosen && (
          <div style={{
            position: 'absolute', top: 8, right: 8,
            background: '#4caf50', color: '#fff',
            borderRadius: 20, padding: '2px 8px',
            fontSize: 11, fontWeight: 800, zIndex: 2,
          }}>
            ✓ Winner!
          </div>
        )}
      </div>

      {/* Content */}
      <div style={{ padding: '12px 12px 14px', display: 'flex', flexDirection: 'column', gap: 6, flexGrow: 1 }}>
        <p style={{
          margin: 0, fontWeight: 800,
          fontSize: 'clamp(12px,2.5vw,15px)',
          color: '#222', lineHeight: 1.3,
        }}>
          {item.name}
        </p>
        <ul style={{ margin: 0, paddingLeft: 16, display: 'flex', flexDirection: 'column', gap: 3 }}>
          {(item.bullets || []).slice(0, 3).map((b, i) => (
            <li key={i} style={{ fontSize: 'clamp(10px,2vw,12px)', color: '#555', lineHeight: 1.4 }}>
              {b}
            </li>
          ))}
        </ul>
        {state === 'idle' && (
          <div style={{
            marginTop: 'auto', paddingTop: 8,
            textAlign: 'center', fontSize: 11,
            fontWeight: 800, color: '#aaa',
            letterSpacing: 1, textTransform: 'uppercase',
          }}>
            Tap to choose ☝️
          </div>
        )}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════
// COMPARE SCREEN
// ══════════════════════════════════════════════════════════════════

function CompareScreen({ comp, progress, pickCount, onChoose, onExit, mode }) {
  const [choiceState, setChoiceState] = useState('idle');
  const [floats, setFloats] = useState([]);
  const [key, setKey] = useState(0);

  const prevCompKey = useRef(null);
  useEffect(() => {
    const ck = comp ? `${comp.a.id}|${comp.b.id}` : null;
    if (ck !== prevCompKey.current) {
      setKey(k => k + 1);
      setChoiceState('idle');
      prevCompKey.current = ck;
    }
  }, [comp]);

  const handleChoose = useCallback((side, e) => {
    if (choiceState !== 'idle') return;
    setChoiceState(`chosen-${side}`);
    if (e) {
      const rect = e.currentTarget.getBoundingClientRect();
      const id = Date.now();
      setFloats(f => [...f, { id, x: rect.left + rect.width / 2, y: rect.top + 20, text: '🏆' }]);
    }
    setTimeout(() => { onChoose(side); }, 420);
  }, [choiceState, onChoose]);

  if (!comp) return null;

  return (
    <div style={{ maxWidth: 640, margin: '0 auto', padding: '16px 12px 24px', display: 'flex', flexDirection: 'column', gap: 10 }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
        <div>
          <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: 18, color: '#7c4dff' }}>
            {mode === 'gifts' ? '⚡ Cool Things' : '🎨 Colors'}
          </div>
          <div style={{ fontSize: 12, color: '#888', fontWeight: 700 }}>
            Pick #{pickCount} · {Math.round(progress * 100)}% done
          </div>
        </div>
        <div style={{ fontSize: 22 }}>
          {['🤔','🧐','😮','🙌','🎯','✨'][pickCount % 6]}
        </div>
      </div>

      {/* Progress bar */}
      <div className="rank-progress-bar">
        <div className="rank-progress-fill" style={{ width: `${progress * 100}%` }} />
      </div>

      {/* Cards row — VS badge overlaps both cards */}
      <div key={key} style={{ display: 'flex', gap: 4, alignItems: 'stretch', minHeight: 300, position: 'relative' }}>
        <CompareCard
          item={comp.a}
          side="a"
          state={choiceState === 'idle' ? 'idle' : choiceState === 'chosen-a' ? 'chosen' : 'rejected'}
          onChoose={(e) => handleChoose('a', e)}
        />
        <div style={{
          position: 'absolute', left: '50%', top: 14,
          transform: 'translateX(-50%)', zIndex: 10, pointerEvents: 'none',
        }}>
          <div className="rank-vs" style={{ border: '3px solid white' }}>VS</div>
        </div>
        <CompareCard
          item={comp.b}
          side="b"
          state={choiceState === 'idle' ? 'idle' : choiceState === 'chosen-b' ? 'chosen' : 'rejected'}
          onChoose={(e) => handleChoose('b', e)}
        />
      </div>

      {/* Hint */}
      <p style={{ textAlign: 'center', color: '#aaa', fontSize: 12, fontWeight: 600, margin: 0 }}>
        Which do you prefer? Tap to pick!
      </p>

      {/* Exit button */}
      <button
        className="rank-btn"
        onClick={onExit}
        style={{
          padding: '10px 0', fontSize: 13, width: '100%',
          background: 'rgba(0,0,0,0.04)', color: '#aaa',
          border: '1.5px solid #ddd',
        }}
      >
        Exit
      </button>

      {floats.map(f => (
        <FloatLabel
          key={f.id}
          text={f.text}
          x={f.x - 16}
          y={f.y}
          onDone={() => setFloats(prev => prev.filter(ff => ff.id !== f.id))}
        />
      ))}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════
// WINNER SCREEN (shown after finding #1; user can share or continue)
// ══════════════════════════════════════════════════════════════════

function WinnerScreen({ champion, mode, onContinue, onRestart }) {
  const [showShare, setShowShare] = useState(false);

  return (
    <div style={{
      minHeight: '100dvh',
      background: 'linear-gradient(180deg,#0a0e2a 0%,#1a1a3e 60%,#0f1030 100%)',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', padding: '24px 16px 40px',
    }}>
      <div style={{ maxWidth: 440, width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 56, marginBottom: 8 }} className="rank-bounce">🏆</div>
          <h1 style={{
            fontFamily: "'Fredoka One', cursive",
            fontSize: 'clamp(26px,6vw,36px)',
            margin: 0, color: '#FFD700',
          }}>
            Your Top Pick!
          </h1>
          <p style={{ color: '#888', fontSize: 13, margin: '6px 0 0' }}>
            Based on your votes
          </p>
        </div>

        <div className="rank-pop" style={{
          borderRadius: 20, overflow: 'hidden',
          border: '2px solid rgba(255,215,0,0.35)',
          boxShadow: '0 0 40px rgba(255,215,0,0.15)',
          marginBottom: 20,
          background: 'rgba(255,255,255,0.04)',
        }}>
          <ItemImage item={champion} height={220} objectFit="contain" />
          <div style={{ padding: '16px 16px 20px' }}>
            <div style={{ fontSize: 11, fontWeight: 800, color: '#FFD700', letterSpacing: 1, marginBottom: 6 }}>
              🥇 WINNER
            </div>
            <div style={{ color: '#fff', fontWeight: 800, fontSize: 'clamp(13px,3vw,16px)', lineHeight: 1.3, marginBottom: 10 }}>
              {champion.name}
            </div>
            <ul style={{ margin: 0, paddingLeft: 16, display: 'flex', flexDirection: 'column', gap: 4 }}>
              {(champion.bullets || []).slice(0, 3).map((b, i) => (
                <li key={i} style={{ fontSize: 12, color: '#bbb', lineHeight: 1.4 }}>{b}</li>
              ))}
            </ul>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button
            className="rank-btn"
            onClick={() => setShowShare(true)}
            style={{
              padding: '15px 0', fontSize: 16, width: '100%',
              background: 'linear-gradient(135deg,#FFD700,#FFA000)',
              color: '#333', boxShadow: '0 6px 24px rgba(255,160,0,0.4)',
            }}
          >
            📤 Share My Pick
          </button>
          <button
            className="rank-btn"
            onClick={onContinue}
            style={{
              padding: '15px 0', fontSize: 16, width: '100%',
              background: 'linear-gradient(135deg,#7c4dff,#42a5f5)',
              color: '#fff', boxShadow: '0 4px 16px rgba(124,77,255,0.3)',
            }}
          >
            📊 Continue to Full Ranking
          </button>
          <button
            className="rank-btn"
            onClick={onRestart}
            style={{
              padding: '12px 0', fontSize: 14, width: '100%',
              background: 'rgba(255,255,255,0.06)', color: '#888',
              border: '1px solid rgba(255,255,255,0.12)',
            }}
          >
            🔁 Start Over
          </button>
        </div>
      </div>

      {showShare && (
        <ShareModal top3={[champion]} mode={mode} onClose={() => setShowShare(false)} />
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════
// RESULTS SCREEN
// ══════════════════════════════════════════════════════════════════

function ShareModal({ top3, mode, onClose }) {
  const [copied, setCopied] = useState(false);
  const text = [
    mode === 'colors' ? '🏆 My Favorite Colors!' : '🏆 My Top Favorites!',
    '',
    top3[0] ? `🥇 ${top3[0].name}` : null,
    top3[1] ? `🥈 ${top3[1].name}` : null,
    top3[2] ? `🥉 ${top3[2].name}` : null,
    '',
    'Ranked with pairwise comparison!',
  ].filter(Boolean).join('\n');

  const doShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title: 'My Rankings', text });
      } else {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    } catch (_) {}
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000, padding: 16,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        className="rank-pop"
        style={{
          background: '#fff', borderRadius: 24, padding: 28,
          maxWidth: 380, width: '100%',
          boxShadow: '0 16px 64px rgba(0,0,0,0.3)',
        }}
      >
        <h2 style={{ fontFamily: "'Fredoka One', cursive", fontSize: 28, margin: '0 0 4px', textAlign: 'center' }}>
          {top3.length === 1 ? '🏆 Your Top Pick' : '🏆 Your Top 3'}
        </h2>
        <p style={{ textAlign: 'center', color: '#888', fontSize: 13, margin: '0 0 20px' }}>
          {top3.length === 1
            ? 'Share your top pick!'
            : mode === 'colors' ? 'Share your color picks!' : 'Share your top picks!'}
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
          {top3.map((item, i) => (
            <div key={item.id} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <ItemImage item={item} height={48} borderRadius={12} />
              <div>
                <div style={{ fontSize: 10, fontWeight: 800, color: ['#f9a825','#9e9e9e','#a0522d'][i], letterSpacing: 1 }}>
                  {['🥇 FIRST PLACE','🥈 SECOND PLACE','🥉 THIRD PLACE'][i]}
                </div>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#222' }}>{item.name}</div>
              </div>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button className="rank-btn" onClick={doShare} style={{
            padding: '14px 0', fontSize: 16, width: '100%',
            background: 'linear-gradient(135deg,#7c4dff,#42a5f5)',
            color: '#fff', boxShadow: '0 4px 16px rgba(124,77,255,0.4)',
          }}>
            {copied ? '✅ Copied!' : navigator.share ? '📤 Share' : '📋 Copy to Clipboard'}
          </button>
          <button className="rank-btn" onClick={onClose} style={{
            padding: '12px 0', fontSize: 14, width: '100%',
            background: '#f5f5f5', color: '#555',
          }}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

function ResultsScreen({ items, comparisons, onRestart, mode, onSwitchMode }) {
  const [showShare, setShowShare] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const isGifts = mode === 'gifts';
  const priceRanks = getPriceRanks(items);
  const top3 = items.slice(0, 3);

  // Mario Kart color scheme
  const bgStyle = {
    minHeight: '100dvh',
    background: 'linear-gradient(180deg,#0a0e2a 0%,#1a1a3e 60%,#0f1030 100%)',
    padding: '0 0 40px',
  };

  const medalColors = ['#FFD700', '#C0C0C0', '#CD7F32'];
  const medalLabel  = ['🥇 1st Place', '🥈 2nd Place', '🥉 3rd Place'];

  return (
    <div style={bgStyle}>
      {/* Header */}
      <div style={{
        textAlign: 'center', padding: '28px 16px 20px',
        background: 'linear-gradient(180deg,#1f2350 0%,transparent 100%)',
      }}>
        <div style={{ fontSize: 48, marginBottom: 4 }} className="rank-bounce">🏁</div>
        <h1 style={{
          fontFamily: "'Fredoka One', cursive",
          fontSize: 'clamp(26px,6vw,40px)',
          margin: 0, color: '#fff', letterSpacing: 1,
        }}>
          Final Rankings!
        </h1>
        <p style={{ color: '#aaa', fontSize: 13, margin: '6px 0 0' }}>
          {comparisons} picks made · {items.length} {isGifts ? 'items' : 'colors'} ranked
        </p>
      </div>

      {/* Top 3 Podium */}
      <div style={{ maxWidth: 600, margin: '0 auto', padding: '0 12px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>
          {top3.map((item, i) => (
            <div
              key={item.id}
              className="rank-result-row"
              style={{
                animationDelay: `${i * 0.1}s`,
                borderRadius: 18,
                overflow: 'hidden',
                border: `2px solid ${medalColors[i]}44`,
                background: i === 0
                  ? 'linear-gradient(135deg,rgba(255,215,0,0.15),rgba(255,215,0,0.05))'
                  : 'rgba(255,255,255,0.05)',
                boxShadow: i === 0 ? `0 0 24px ${medalColors[i]}33` : 'none',
                position: 'relative',
              }}
            >
              {/* Shimmer on #1 */}
              {i === 0 && (
                <div className="rank-shimmer" style={{
                  position: 'absolute', inset: 0, borderRadius: 18, pointerEvents: 'none', zIndex: 1,
                }} />
              )}
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 14px', position: 'relative', zIndex: 2 }}>
                {/* Rank badge */}
                <div style={{
                  width: 42, height: 42, borderRadius: 12, flexShrink: 0,
                  background: `linear-gradient(135deg,${medalColors[i]},${medalColors[i]}88)`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: i === 0 ? 22 : 18,
                  boxShadow: `0 4px 12px ${medalColors[i]}44`,
                }}>
                  {['🥇','🥈','🥉'][i]}
                </div>

                {/* Thumbnail */}
                <ItemImage item={item} height={52} borderRadius={12} />

                {/* Name + label */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{
                    fontSize: 10, fontWeight: 800, letterSpacing: 1,
                    color: medalColors[i], marginBottom: 3,
                  }}>
                    {medalLabel[i].toUpperCase()}
                  </div>
                  <div style={{
                    color: '#fff', fontWeight: 800,
                    fontSize: 'clamp(11px,2.8vw,14px)',
                    lineHeight: 1.3,
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                  }}>
                    {item.name}
                  </div>
                </div>

                {/* Arrow vs baseline */}
                <ComparisonArrow
                  userRank={i + 1}
                  priceRank={priceRanks[item.id]}
                  isGifts={isGifts}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Others' Choices legend */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'flex-end',
          marginBottom: 8, paddingRight: 4,
        }}>
          <span style={{ fontSize: 11, color: '#666', fontWeight: 600 }}>vs. "Others' Choices"</span>
          <span style={{ fontSize: 10, color: '#4caf50', fontWeight: 800 }}>▲ ranked higher</span>
          <span style={{ fontSize: 10, color: '#9e9e9e', fontWeight: 800 }}>━ same</span>
          <span style={{ fontSize: 10, color: '#f44336', fontWeight: 800 }}>▼ ranked lower</span>
        </div>

        {/* Rest of ranking */}
        <div
          style={{
            background: 'rgba(255,255,255,0.04)',
            borderRadius: 16,
            border: '1px solid rgba(255,255,255,0.08)',
            overflow: 'hidden',
            marginBottom: 8,
          }}
        >
          {(showAll ? items : items.slice(0, 8)).map((item, i) => {
            return (
              <div
                key={item.id}
                className="rank-result-row"
                style={{
                  animationDelay: `${Math.min(i,8) * 0.05}s`,
                  display: 'flex', alignItems: 'center', gap: 10,
                  padding: '10px 14px',
                  borderBottom: i < items.length - 1 ? '1px solid rgba(255,255,255,0.06)' : 'none',
                  background: i < 3
                    ? `linear-gradient(90deg,${medalColors[i]}11,transparent)`
                    : 'transparent',
                }}
              >
                <div style={{
                  width: 28, textAlign: 'center', flexShrink: 0,
                  fontFamily: "'Fredoka One', cursive",
                  fontSize: i < 3 ? 16 : 14,
                  color: i < 3 ? medalColors[i] : '#666',
                  fontWeight: 800,
                }}>
                  {i < 3 ? ['🥇','🥈','🥉'][i] : i + 1}
                </div>

                <ItemImage item={item} height={36} borderRadius={10} />

                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{
                    color: '#ddd', fontSize: 'clamp(10px,2.5vw,13px)',
                    fontWeight: 700, lineHeight: 1.3,
                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                  }}>
                    {item.name}
                  </div>
                </div>

                <ComparisonArrow
                  userRank={i + 1}
                  priceRank={priceRanks[item.id]}
                  isGifts={isGifts}
                  compact
                />
              </div>
            );
          })}
        </div>

        {items.length > 8 && (
          <button
            className="rank-btn"
            onClick={() => setShowAll(v => !v)}
            style={{
              width: '100%', padding: '10px 0', fontSize: 14,
              background: 'rgba(255,255,255,0.08)', color: '#aaa',
              border: '1px solid rgba(255,255,255,0.1)',
              marginBottom: 16,
            }}
          >
            {showAll ? '▲ Show Less' : `▼ Show All ${items.length} Items`}
          </button>
        )}

        {/* Action buttons */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button
            className="rank-btn"
            onClick={() => setShowShare(true)}
            style={{
              padding: '16px 0', fontSize: 18, width: '100%',
              background: 'linear-gradient(135deg,#FFD700,#FFA000)',
              color: '#333', boxShadow: '0 6px 24px rgba(255,160,0,0.4)',
            }}
          >
            📤 Share My Top 3
          </button>

          <div style={{ display: 'flex', gap: 10 }}>
            <button
              className="rank-btn"
              onClick={onRestart}
              style={{
                flex: 1, padding: '14px 0', fontSize: 15,
                background: 'rgba(255,255,255,0.08)', color: '#ddd',
                border: '1px solid rgba(255,255,255,0.15)',
              }}
            >
              🔁 Try Again
            </button>
            <button
              className="rank-btn"
              onClick={() => onSwitchMode(isGifts ? 'colors' : 'gifts')}
              style={{
                flex: 1, padding: '14px 0', fontSize: 15,
                background: 'linear-gradient(135deg,#7c4dff,#42a5f5)',
                color: '#fff', boxShadow: '0 4px 16px rgba(124,77,255,0.3)',
              }}
            >
              {isGifts ? '🎨 Rank Colors' : '⚡ Rank Things'}
            </button>
          </div>
        </div>
      </div>

      {showShare && (
        <ShareModal top3={top3} mode={mode} onClose={() => setShowShare(false)} />
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════
// COMPARISON ARROW WIDGET
// ══════════════════════════════════════════════════════════════════

function ComparisonArrow({ userRank, priceRank, isGifts, compact = false }) {
  const arrow = getArrowInfo(userRank, priceRank);
  const diff = priceRank - userRank;

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      flexShrink: 0, minWidth: compact ? 32 : 44,
    }}>
      <div style={{
        color: arrow.color,
        fontSize: compact ? 14 : 18,
        fontWeight: 900,
        lineHeight: 1,
      }}>
        {arrow.symbol}
      </div>
      {!compact && (
        <div style={{ fontSize: 9, color: arrow.color, fontWeight: 700, marginTop: 2 }}>
          {diff === 0 ? 'same' : `${diff > 0 ? '+' : ''}${diff}`}
        </div>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ══════════════════════════════════════════════════════════════════

export default function Rank() {
  // Aggressively preload all images as soon as the page mounts
  useEffect(() => {
    [...GIFTS, ...COLORS_DATA].forEach(item => {
      if (item.imageFile) {
        const img = new window.Image();
        img.src = `/rank-items/${item.imageFile}`;
      }
    });
  }, []);

  // phases: intro | findTop | winner | fullSort | results
  const [phase, setPhase] = useState('intro');
  const [mode,  setMode]  = useState('gifts');
  const [findTopState, setFindTopState] = useState(null);
  const [sortState,    setSortState]    = useState(null);
  const [hasCompletedThings, setHasCompletedThings] = useState(false);

  const handleStart = useCallback((selectedMode) => {
    const items = selectedMode === 'gifts' ? GIFTS : COLORS_DATA;
    setMode(selectedMode);
    setFindTopState(initFindTop(items));
    setSortState(null);
    setPhase('findTop');
  }, []);

  const handleFindTopChoose = useCallback((choice) => {
    setFindTopState(prev => applyFindTopChoice(prev, choice));
  }, []);

  const handleSortChoose = useCallback((choice) => {
    setSortState(prev => applyChoice(prev, choice));
  }, []);

  // findTop done → winner screen; unlock colors mode for gifts
  useEffect(() => {
    if (findTopState?.done && phase === 'findTop') {
      if (mode === 'gifts') setHasCompletedThings(true);
      const t = setTimeout(() => setPhase('winner'), 300);
      return () => clearTimeout(t);
    }
  }, [findTopState?.done, phase, mode]);

  // fullSort done → results screen
  useEffect(() => {
    if (sortState?.done && phase === 'fullSort') {
      if (mode === 'gifts') setHasCompletedThings(true);
      const t = setTimeout(() => setPhase('results'), 300);
      return () => clearTimeout(t);
    }
  }, [sortState?.done, phase, mode]);

  const handleContinue = useCallback(() => {
    setSortState(initSort(findTopState.losers));
    setPhase('fullSort');
  }, [findTopState]);

  const handleRestart = useCallback(() => {
    setFindTopState(null);
    setSortState(null);
    setPhase('intro');
  }, []);

  const handleSwitchMode = useCallback((newMode) => {
    setMode(newMode);
    setFindTopState(null);
    setSortState(null);
    setPhase('intro');
  }, []);

  // Compute what to pass to CompareScreen
  const compareProps = useMemo(() => {
    if (phase === 'findTop' && findTopState && !findTopState.done) {
      const comp = getFindTopComp(findTopState);
      const progress = findTopState.comparisons / (findTopState.totalItems - 1);
      return { comp, progress, pickCount: findTopState.comparisons + 1, onChoose: handleFindTopChoose };
    }
    if (phase === 'fullSort' && sortState && !sortState.done) {
      const comp = getComparison(sortState);
      const progress = getProgress(sortState);
      return { comp, progress, pickCount: sortState.comparisons + 1, onChoose: handleSortChoose };
    }
    return null;
  }, [phase, findTopState, sortState, handleFindTopChoose, handleSortChoose]);

  // Full results = champion (#1) + sorted losers (#2–N)
  const fullResults = useMemo(() => {
    if (!findTopState || !sortState?.done) return null;
    return [findTopState.champion, ...sortState.sorted];
  }, [findTopState, sortState]);

  const totalComparisons = (findTopState?.comparisons ?? 0) + (sortState?.comparisons ?? 0);

  const isDark = phase === 'winner' || phase === 'results';

  return (
    <div className={isDark ? undefined : 'rank-grid-bg'} style={{ minHeight: '100dvh' }}>
      {phase === 'intro' && (
        <IntroScreen
          onStart={handleStart}
          mode={mode}
          hasCompletedThings={hasCompletedThings}
        />
      )}
      {(phase === 'findTop' || phase === 'fullSort') && compareProps && (
        <CompareScreen
          comp={compareProps.comp}
          progress={compareProps.progress}
          pickCount={compareProps.pickCount}
          onChoose={compareProps.onChoose}
          onExit={handleRestart}
          mode={mode}
        />
      )}
      {phase === 'winner' && findTopState && (
        <WinnerScreen
          champion={findTopState.champion}
          mode={mode}
          onContinue={handleContinue}
          onRestart={handleRestart}
        />
      )}
      {phase === 'results' && fullResults && (
        <ResultsScreen
          items={fullResults}
          comparisons={totalComparisons}
          onRestart={handleRestart}
          mode={mode}
          onSwitchMode={handleSwitchMode}
        />
      )}
    </div>
  );
}
